import { Button, IconButton, Link } from "@mui/material"
import { FaDonate } from "react-icons/fa";

const BuyMeACoffee = ()=> {
  return <Button LinkComponent={Link} href="https://www.buymeacoffee.com/thepkvtechC" startIcon={<FaDonate/>} target="_blank">Buy me a coffee</Button>
}
export default BuyMeACoffee;